/**
 * Per-tab guard for the `landing_path` redirect.
 *
 * Lives in `lib/` (not `router.tsx`) so AuthProvider can clear it on logout
 * without pulling in the router module and its big page-component fan-in.
 *
 * sessionStorage is the right scope: each tab gets its own copy (so two
 * tabs can independently land on their preferred page), but it survives
 * soft-navigation inside the SPA — unlike a per-mount `useRef`, which used
 * to reset every time `<NavLink to="/">` re-mounted the Landing component.
 */
export const LANDING_APPLIED_KEY = 'fasto-bi:landing-applied';

export function isLandingAlreadyApplied(): boolean {
  try {
    return sessionStorage.getItem(LANDING_APPLIED_KEY) === '1';
  } catch {
    return false;
  }
}

export function markLandingApplied(): void {
  try {
    sessionStorage.setItem(LANDING_APPLIED_KEY, '1');
  } catch {
    /* private mode etc */
  }
}

export function clearLandingRedirectFlag(): void {
  try {
    sessionStorage.removeItem(LANDING_APPLIED_KEY);
  } catch {
    /* private mode etc */
  }
}
